import png from './images/rabbitohs.png'

export const colors = {
  dominant: '#00A861',
  highlight: '#fcb53e',
}
export const fullname = 'Rabbitohs'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/rabbitohs.js